
















































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import TreeHierarchy from '@/components/TreeHierarchy.vue';
import MaterialsListPrintTool from '@/components/MaterialsListPrintTool.vue';
import ProductGenericDocumentsList from '@/components/ProductGenericDocumentsList.vue';
import UploadSingleDocument from '@/components/UploadSingleDocument.vue';
import { ClaimEnum } from '@/services/ClaimEnum';
import {ProductBase} from '@/entity/ProductBase';

@Component({
    components: {
        TreeHierarchy,
        MaterialsListPrintTool,
        ProductGenericDocumentsList,
        UploadSingleDocument
    }
})
export default class ProductDetail extends Vue {
    @Prop()
    public idproduct!: any;

    @Prop()
    idModel: string;

    @Prop()
    showClose: boolean;
    tabActivated: number;
    uploadSingleDocument_DocumentType: string = null;
    loading: boolean = true;
    product: any = {};
    general: any = {};
    isPublicSelected: any = '-';
    publicOptions = [
   
    ]
    fileRowSelected:any = null;
    treeHierarchyLevel: number = 6;
    collapseTreeHierarchyVisibility:boolean = false;
    mergeDocuments(): any[] {
        let outputDocuments: any[] = [];
        for (let document of this.product.documents) {
            if (document.culture.friendlyName != "Default Culture") { //per escludere i GENERIC
                if (!this.findByCulture(document.culture.idCulture, outputDocuments)) {
                    let singleRow = {
                        culture: document.culture,
                        canBeDeleted: document.canBeDeleted,
                        documentSds: this.filesFilterBy('SDS', document.culture.idCulture),
                        documentPds: this.filesFilterBy('PDS', document.culture.idCulture),
                        documentPdsDOCX: this.filesFilterBy('PDSDOCX', document.culture.idCulture)
                    };
                    outputDocuments.push(singleRow);
                }
            }
        }
        return outputDocuments.sort((n1, n2) => {
            if (n1.culture.language.name > n2.culture.language.name) {
                return 1;
            }
            if (n1.culture.language.name < n2.culture.language.name) {
                return -1;
            }
            return 0;
        });
    }
    close() {
        this.$bvModal.hide('product-detail-modal');
    }

    afterMaterialDetailEditProduct() {
        this.refresh();
    }

    deleteProduct(): void {
        let app = this;
        let callDeletion = (): void => {
            app.deletion();
        }
        General.confirm(this.$t('PRODUCT.CONFIRM_DELETE') as string, app, callDeletion);
    }
    async saveProduct(){
        let app = this;
        let callSaving = async () =>  {
            await app.saveProductDo();
        }
        General.confirm(this.$t('PRODUCT.CONFIRM_SAVE') as string, app, callSaving);

    }

    async saveProductDo(){

        let app = this;
        let error = false;

        let productBase = new ProductBase();
        productBase.IdProduct = this.idproduct;
        productBase.OldCode = this.product.oldCode;
        productBase.Description = this.product.description;
        productBase.TreeHierarchyCode = this.product.treeHierarchyCode;
        productBase.Approvals = this.product.approvals;
        productBase.Viscosity = this.product.viscosity;
        productBase.TechSpecs = this.product.techSpecs;
        productBase.PerformanceLevel = this.product.performanceLevel;
        productBase.IsPublic = this.product.isPublic;
        productBase.Sperimental = this.product.sperimental
        productBase.Edible = this.product.edible;
        productBase.NonfoodCompounds = this.product.nonfoodCompounds;
         
        General.mainLoading(true);
        try{
        await axios.post(General.GetApiUrl('/api/product/UpdateProduct'),productBase,{ withCredentials: true });
        }catch(error){
            General.HandleError(error, app);
            error = true; 

        }
        General.mainLoading(false);  

        if (!error) app.$bvModal.hide('product-detail-modal');

    }
    async deletion() {
        let app = this;
        General.mainLoading(true);
        await axios({
            method: 'delete',
            url: General.GetApiUrl('/api/product/DeleteProduct?idProduct=' + this.idproduct),
            responseType: 'json',
            withCredentials: true
        }).then(function (response) {
            app.$bvModal.hide('product-detail-modal');
            General.mainLoading(false);
        }).catch(error => {
            General.HandleError(error, app);
            General.mainLoading(false);
        });
    }
    findByCulture(idCulture: string, documentsIn: any[]): boolean {
        let documents: any[] = documentsIn.filter(item =>
            item.culture.idCulture == idCulture
        );
        if (documents.length > 0) return true;
        return false;
    }
    filesFilterBy(type: string, idCulture: string): any[] {
        let documents: any[] = this.product.documents.filter(item =>
            item.documentTypeCode == type && item.culture.idCulture == idCulture
        );
        if (documents.length == 0) return null;
        return documents[0];
    }
    get showDelete(): boolean {
        return General.CheckAuthorization(ClaimEnum.CanDeleteProduct);
    }
    get showUpload(): boolean {
        return General.CheckAuthorization(ClaimEnum.CanUploadDocument);
    }
    get showSave(): boolean{
        return this.editBaseInfo||this.editTechSpecs;

    }

    get editBaseInfo(): boolean{
        let isUserAuthorized = General.CheckAuthorization(ClaimEnum.CanEditProduct);
        let isProductManagedBySAP = this.product.importedFromSAP;
        return (isUserAuthorized && !isProductManagedBySAP)
    }
    
    get editSperimentalInfo(): boolean{
        let isUserAuthorized = General.CheckAuthorization(ClaimEnum.CanEditProduct);
        return isUserAuthorized;
    }

    get editTechSpecs(): boolean{
        let isUserAuthorized = General.CheckAuthorization(ClaimEnum.CanUploadTechSpecs);           

        return isUserAuthorized;
    }
    mounted() {
        this.tabActivated = 0;
        this.publicOptions = [{ value: true, text: this.$t('PRODUCT.PUBLIC') as string },
            { value: false, text: this.$t('PRODUCT.NON_PUBLIC') as string }]
        this.refresh();
    }
    rowSelector(item: any) {
        if (item == null)
            this.fileRowSelected = null;
        else
            this.fileRowSelected = item.culture.idCulture;
        
    }
    async deleteFile(idDocument: any) {
        let app = this;
        let callDeletion = async () => {
            General.mainLoading(true);
            try {

                await axios({
                    method: 'post',
                    url: General.GetApiUrl('/api/document/DeleteGenericDocument?idDocument=' + idDocument),
                    responseType: 'json',
                    withCredentials: true
                });
                General.mainLoading(false);
                app.refresh()
            } catch (error) {
                General.HandleError(error, this);
                General.mainLoading(false);
            }
        }

        General.confirm(this.$t('PRODUCT.CONFIRM_DELETE') as string, app, await callDeletion);
    }
    async refresh() {
        this.loading = true;
        let app = this;
        
        try{
            var productResponse = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/product/GetProductById?productId=' + this.idproduct),
                responseType: 'json',
                withCredentials: true

            });
        

            this.product = productResponse.data;
                        
            this.product.materials.forEach(el=>{
                    el.product = app.product
                });
            
            this.loading = false;
            this.isPublicSelected = this.product.isPublic;
            this.general = General;
        }catch(error){
            General.HandleError(error, this);

        }
    }
    openUploadSingleDocumentModalPDS() {
        this.uploadSingleDocument_DocumentType = "PDS";
        this.$bvModal.show('upload-single-document-modal');
    }
    openUploadSingleDocumentModalPDSDOCX() {
        this.uploadSingleDocument_DocumentType = "PDSDOCX";
        this.$bvModal.show('upload-single-document-modal');
    }
    
}
